import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { aiakosBaseQuery } from "../../client/AiakosClient";

// Validates whether an auth token is valid
export const authService = createApi({
  reducerPath: "authService",
  baseQuery: fetchBaseQuery(aiakosBaseQuery),
  tagTypes: ["Auth"],
  endpoints: (builder) => ({
    checkAuthentication: builder.query<
      boolean,
      {
        verifyTokenUri: string;
      }
    >({
      query: (data) => data.verifyTokenUri,
      transformResponse: (_response, meta, _arg) => {
        if (meta?.response?.status === 200) {
          return true;
        }
        return false;
      },
      providesTags: [{ type: "Auth" }],
    }),
  }),
});

export const { useCheckAuthenticationQuery, useLazyCheckAuthenticationQuery } =
  authService;
